import TagManagerUtil from '@component/common/src/util/TagManagerUtil';

module.exports = function loadTealiumAsync(app) {
  app.channel.on('load:tealium-scripts:async', (brand, env, lazyLoadTealiumEnabled) => {
    if (lazyLoadTealiumEnabled) {
      TagManagerUtil.loadTagLibrary(brand, env);
    }
  });
};
